export enum CustomDataUsageEnum {
	None = 'none',
	OptIn = 'opt-in',
	Intro = 'intro',
	Both = 'both'
}
